require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./goals-find-a-partner.json") })
        }
      }, "path---goals-find-a-partner");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---goals-find-a-partner!./.cache/json/goals-find-a-partner.json
// module id = 357
// module chunks = 231608221292675